import React from 'react';
import { useNavigate } from 'react-router-dom';
import ToolCard from '@/components/tools/ToolCard';
import styles from '@/styles/pages/ToolsPage.module.css';

const ToolsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.page} role="main" aria-label="Tools">
      <div className={styles.center}>
        <ToolCard
          title="News Summarizer"
          description="This agent helps you quickly understand what has been happening around a specific topic. Provide a keyword, and the agent will analyze recent news and return a concise summary of the most relevant events and themes."
          tags={['codetool', 'llama', 'chat']}
          onRun={() => navigate('/tools/summarizer')}
        />
      </div>
    </div>
  );
};

export default ToolsPage;

